import "../styles/Landing.css"

export default function AboutPage() {

  return (
    <div></div>
  );
}